<template>
	<div class="boardPopup" style="width: 900px; height: 750px; padding-left: 10px;">
		<section class="sub_contents">
			<div class="sub_contents_wrap" style="width: 100%;">
				<component :is="currentPolicy"></component>

				<div class="policy-footer" style="margin-top: 50px; border-top: 1px solid #eee; padding-top: 30px;">
					<div class="history-grid" style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 10px;">
						<button v-for="(policy, index) in reversedList" :key="index" @click="selectPolicy(index)"
							:class="{ active: currentPolicy === policy.componentName }" class="policy-btn">
							<span class="sub-text">이전 개인정보 처리방침 보기</span>
							<span class="main-text">개정일자 {{ policy.date }}</span>
						</button>
					</div>
				</div>

			</div>
		</section>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'
import PrivacyPolicy_20240814 from '@/views/privacy/PrivacyPolicy_20240814'
import PrivacyPolicy_20260129 from '@/views/privacy/PrivacyPolicy_20260129'
import PrivacyPolicy_20260326 from '@/views/privacy/PrivacyPolicy_20260326'
import PrivacyPolicy_20260806 from '@/views/privacy/PrivacyPolicy_20260806'
import PrivacyPolicy_20260828 from '@/views/privacy/PrivacyPolicy_20260828'
import { computed } from 'vue'

export default {
	name: 'coursePopup',
	components: {
		PrivacyPolicy_20240814,
		PrivacyPolicy_20260129,
    PrivacyPolicy_20260326,
    PrivacyPolicy_20260806,
    PrivacyPolicy_20260828
	},
  computed: {
    reversedList() {
      return this.policyList.slice(0, -1).reverse();
    }
  },
	data() {
    const policyList = [
      { date: '2024-08-14', componentName: 'PrivacyPolicy_20240814' },
      { date: '2026-01-29', componentName: 'PrivacyPolicy_20260129' },
      { date: '2026-03-26', componentName: 'PrivacyPolicy_20260326' },
      { date: '2026-08-06', componentName: 'PrivacyPolicy_20260806' },
      { date: '2026-08-28', componentName: 'PrivacyPolicy_20260828' }
    ]
		return {
      policyList,
			currentPolicy: ''
		}
	},
	watch: {
		'$route.query.seq': {
			handler: 'initPolicy',
			immediate: true
		}
	},
	created() {
	},
  mounted() {
		const vm = this;
		Vue.httpClient.defaults.headers.common['x-auth-token'] = Vue.$sessionStorage.get('xAuthToken');
		$('#wrapper').css('min-width', '500px');

	},
	methods: {
    initPolicy() {
			// URL 파라미터(seq)가 있으면 해당 시퀀스의 이전 방침을, 없으면 최신 방침을 보여줌
			const seq = this.$route.query.seq;
			if (seq !== undefined && seq !== null && seq !== '') {
				const idx = parseInt(seq, 10);
				if (this.reversedList[idx]) {
					this.currentPolicy = this.reversedList[idx].componentName;
				} else {
					// 유효하지 않은 시퀀스면 최신 방침
					this.currentPolicy = this.policyList[this.policyList.length - 1].componentName;
				}
			} else {
				// 파라미터가 없으면 최신 방침
				this.currentPolicy = this.policyList[this.policyList.length - 1].componentName;
			}
			setTimeout(() => {
				window.scrollTo(0, 0);
			}, 10);
		},
		selectPolicy(index) {
			this.$router.push({ query: { seq: index } });
		},
		permanentlyClose(dataList) {
			const params = {
				"bulletinBoardNo": this.virtualAccountNumber
				, "popupType": 'order'
			}

			Vue.httpClient
				.post('/board/permanentlyClose', params)
				.then(response => {
					if (response.data.status == AppConfig.HTTP_RESPONSE_SUCCESS) {
						self.close();
					}
				})


		}
	}
}
</script>

<style scoped>
#wrapper {
	min-width: 500px;
}

table {
	width: 70%
}

table,
th,
td {
	border: 1px solid black;
	text-align: center;
}

.policy-btn {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	padding: 15px;
	border: 1px solid #ddd;
	background: #fff;
	border-radius: 8px;
	cursor: pointer;
	text-align: left;
	height: 80px;
}

.policy-btn:hover {
	border-color: #999;
}

.policy-btn.active {
	border-color: #333;
	background-color: #f9f9f9;
}

.policy-btn .sub-text {
	font-size: 12px;
	color: #888;
	margin-bottom: 5px;
}

.policy-btn .main-text {
	font-size: 14px;
	font-weight: bold;
	color: #333;
}
</style>



// WEBPACK FOOTER //
// src/views/CoursePopup.vue